import React from 'react';
import "./Login.css";
import { Button } from '@material-ui/core';
import { auth, provider } from "./firebase";
import { useStateValue } from "./StateProvider";
import { actionTypes } from "./reducer";

function Login() {

    const [{ }, dispatch] = useStateValue();

    const signIn = () => {
        auth
            .signInWithPopup(provider)
            .then((result) => {
                dispatch({
                    type: actionTypes.SET_USER,
                    user: result.user,
                })
            }
                // console.log(result)
            )
            .catch((error) => alert(error.messaage));
    };

    return (
        <div className="login">
            <div className="login__container">

                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/c/cd/Logo-bw-vertical.png"
                    alt=""
                />

                <div className="login__text">
                    <h2>What's Up?</h2>
                </div>

                <Button type="submit" onClick={signIn}>
                    Sign In with Google
            </Button>

                <h4>by Arefat Hyeredin</h4>
            </div>

        </div>
    );
}

export default Login;
